export const buttonText = 'Buscar';
export const variableName = '';
